module.exports = __webpack_public_path__ + "img/quest_icon_0020_quest.70d9715f.png";